import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EventQRScanner from '@/components/molecules/EventQRScanner/EventQRScanner';
import Button from '@/components/atoms/Button';
import Icon from '@/components/atoms/Icon/Icon';
import Loader from '@/components/atoms/Loader';
import './QRScanner.scss';

const QRScannerPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const eventIdRef = useRef<number | null>(null);

  const handleEventScanned = (eventId: number) => {
    // Store the event ID and show loader
    eventIdRef.current = eventId;
    setShowLoader(true);
  };

  const handleLoaderComplete = () => {
    // Navigate to the event details page after GIF completes
    if (eventIdRef.current) {
      navigate(`/events/${eventIdRef.current}/venues/0`);
    }
  };

  // Show loader when event is scanned
  if (showLoader) {
    return <Loader fullScreen size="lg" onAnimationComplete={handleLoaderComplete} />;
  }

  return (
    <div className="container">
      <div className="qr-scanner-page">
        <div className="qr-scanner-page__header">

          <Button 
            variant="outline" 
            size="sm"
            onClick={() => navigate('/events')}
          >
            <Icon name="atras" size={20}  />  {/*{t('common.back')}*/}
          </Button>
          
          <h1 className="qr-scanner-page__title">{t('qrScanner.title')}</h1>
        </div>

        <div className="qr-scanner-page__content">
          <EventQRScanner 
            onEventScanned={handleEventScanned}
            className="qr-scanner-page__scanner"
          />
        </div>
      </div>
    </div>
  );
};

export default QRScannerPage;
